import React from "react";

import { IonAccordionGroup } from "@ionic/react";

import GettingStarted from "./components/GettingStarted";
import PlayingScoring from "./components/PlayingScoring";
import FinishingYourQuiz from "./components/FinishingYourQuiz";
import HomeMenuFunction from "./components/HomeMenuFunction";
import TroubleShootingHelp from "./components/TroubleShootingHelp";
import VenueHostTips from "./components/VenueHostTips";
import ResultsHelp from "./components/ResultsHelp";

export interface Props {}

const QwizardHelp: React.FC<Props> = () => {
  return (
    <div className="help" style={{ padding: "3px" }}>
      <div>
        <h3>Introduction</h3>
        <p>
          Qwizard is the only app-based quiz format in the market. This means,
          amongst many other advantages, teams see live results during a quiz
          and online analysis of their quiz after each event. Teams at our
          regular events are effectively competing against other teams who are
          playing on the same night. Read these Help options to get a full
          understanding of how Qwizard works and to ensure you maximise the
          benefits for your quiz.
        </p>
      </div>
      <IonAccordionGroup>
        <GettingStarted />
        <PlayingScoring />
        <FinishingYourQuiz />
        <HomeMenuFunction />
        <TroubleShootingHelp />
        <VenueHostTips />
        <ResultsHelp />
      </IonAccordionGroup>
    </div>
  );
};

export default QwizardHelp;
